document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', menu.classList.contains('is-open'));
    });
  }

  // Header goes solid ink on scroll (for transparent hero headers)
  var header = document.querySelector('[data-site-header]');
  if (header && header.classList.contains('vsa-header--transparent')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Collection sort-by select navigates with ?sort_by=
  document.querySelectorAll('[data-sort-select]').forEach(function (el) {
    el.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      window.location.href = url.toString();
    });
  });

  // Upload dropzone (visual only — wire to a real upload field/app in Shopify)
  document.querySelectorAll('[data-upload]').forEach(function (zone) {
    var input = zone.querySelector('input[type="file"]');
    var label = zone.querySelector('[data-upload-label]');
    zone.addEventListener('click', function () { input && input.click(); });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.style.borderColor = 'var(--accent-primary)'; });
    zone.addEventListener('dragleave', function () { zone.style.borderColor = ''; });
    if (input) {
      input.addEventListener('change', function () {
        if (input.files && input.files.length && label) {
          label.textContent = input.files.length + ' file(s) selected';
        }
      });
    }
  });

  // Prefill the quote form's service/description fields from a ?product= query param
  // (linked from product pages tagged "quote-only")
  var params = new URLSearchParams(window.location.search);
  var productParam = params.get('product');
  if (productParam) {
    var desc = document.querySelector('[data-quote-description]');
    if (desc && !desc.value) {
      desc.value = 'Regarding: ' + productParam + '\n\n';
    }
  }
});
